import React from 'react';
const Animate = ({ className, animateClass, animate, children }) => {
  const finalClass = animate ? `${animateClass}` : className;
  const visibilityStyle = animate ? 'visible' : 'hidden';
  return (
    <div
      data-testid="primary-menu"
      className={finalClass}
      // For testing, this needs to be an inline style rather than a CSS style.
      // jsdom cannot guarantee all the CSS will be loaded
      style={{ visibility: visibilityStyle }}
    >
      {children}
    </div>
  );
};

export default Animate;
